'use client';
export { default } from './components/faqs';
